const fundebugConfig = {
  apikey: 'cea7d6e4a0e65c3e3f846998fbbce503396c0d8812d8b7f68c8e97b96c8960a0',
  silentResource: true,
  filters: [
    {
      type: /^unhandledrejection$/,
    },
    {
      name: /^caught error$/,
    },
    {
      message: /^Script error\.$/,
    },
    {
      req: {
        method: /^GET$/,
      },
      res: {
        status: /^0$/,
      },
    },
    {
      req: {
        method: /^POST$/,
      },
      res: {
        status: /^0$/,
      },
    },
  ],
};

const errorHandler = function ({ fundebug, error, extInfo }) {
  try {
    fundebug.notifyError(error, {
      metaData: {
        extInfo,
      },
    });
  } catch (err) {
    // 什么也不做...
  }
};

module.exports = { fundebugConfig, errorHandler };
